<template>
    <div>
        <div class="old_progress">
            <span class="old_progress_icon"></span>
            <div class="old_progress_all">排产量<span class="old_progress_all_num">{{allNum}}吨</span></div>
        </div>
        <!-- <div class="new_progress">
            <span class="new_progress_icon"></span>
            <div class="new_progress_all"></div>
            <div class="new_progress_all_over" :style="{width: numWidth}"></div>
            <span class="new_progress_all_text">完成量</span>
            <span class="new_progress_all_num">{{overNum}}吨</span>
        </div>  -->
        <div class="new_progress">
            <span class="new_progress_icon"></span>
            <div class="new_progress_all" :style="{width: numWidth}">完成量<span class="new_progress_all_num">{{overNum}}吨</span></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            allNum:{type:String},
            overNum:{type:String},
        },
        data () {
            return {
                numWidth:'',
            };
        },
        computed: {
        },
        mounted () {
            this.getNum();
        },
        methods: {
            getNum(){
                this.numWidth =  Math.round(this.overNum/this.allNum*167) +'px';
            }
        }
    };
</script>

<style scoped lang="scss">
    .old_progress{
        width:167px;
        position:relative;
        margin-bottom:20px;
        .old_progress_icon{
            width:23px;
            height:24px;
            position:absolute;
            left:0px;
            top:1px;
            background:url(../assets/img/home_clockbg_6.png) no-repeat left top;
        }
        .old_progress_all{
            margin-left:11px;
            width:167px;
            height:25px;
            line-height:25px;
            border-radius:4px;
            padding-left:20px;
            background: -webkit-linear-gradient(#16296b, #23bbbc);
            background: -o-linear-gradient(#16296b, #23bbbc);
            background: -moz-linear-gradient(#16296b, #23bbbc); 
            background: linear-gradient(#16296b, #23bbbc); 
            color:#fff;
            .old_progress_all_num{float:right;margin-right:10px;}
        }
    }
    .new_progress{
        width:167px;
        margin-left:11px;
        position:relative;
        margin-bottom:20px;
        background: #1f2813;
        border-radius:4px;
        .new_progress_all_num{
            position:absolute;
            right:10px;
            top:0px;
        }
        .new_progress_icon{
            width:23px;
            height:24px;
            position:absolute;
            left:-11px;
            top:1px;
            background:url(../assets/img/home_clockbg_7.png) no-repeat left top;
        }
        .new_progress_all{
            width:156px;
            height:25px;
            line-height:25px;
            border-radius:4px;
            padding-left:20px;
            background: -webkit-linear-gradient(#01bb8a, #012018);
            background: -o-linear-gradient(#01bb8a, #012018);
            background: -moz-linear-gradient(#01bb8a, #012018); 
            background: linear-gradient(#01bb8a, #012018); 
            color:#fff;
        }
    }
</style>



// WEBPACK FOOTER //
// progressCard.vue?c2b0e6d2